export enum PromptInitialRoleEnum {
  System = 'system',
  User = 'user',
  Assistant = 'assistant',
}
